import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useDisableBodyScroll } from "../../hooks/useDisableBodyScroll";
import { addUserActivity, duplicateUserActivity, removeUserActivity, selectUserActivity, setUserActivity, togglePreference } from "../../redux/slices/userActivity";
import AddActivityIcon from "../../assets/icons/add-activity.svg";
import MenuIcon from "../../assets/icons/menu-icon.svg";
import useHorizontalScroll from "../../hooks/useHorizontalScroll";
import { useEffect } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import VideoController from "./VideoController/videoController";
import { getTime } from "../../utils";

export default function ActivityPagination({ slidesActive, setSlidesActive, playerRef, videoDetails }) {
  const { userActivities, selectedUserActivity, defaultUserActivities, isEditing, isVideo } = useSelector((state) => state.userActivity);
  const dispatch = useDispatch();
  const scrollRef = useHorizontalScroll();
  const { width } = useWindowDimensions();
  const { title, video, video_url } = useSelector((state) => state.duonutSettings.settings);

  const addVideoActivity = () => {
    if(video === null && video_url === null) return alert('Please add a video first')
    dispatch(togglePreference({
      preferenceActive: true,
      defaultPreference: { timestamp: 0, dropdownId: 1 },
      preferenceEditing: false
    }))
  }

  const addActivity = () => {
    var promise = new Promise((resolve, reject) => {
      dispatch(addUserActivity({}));
      resolve("Promise resolved successfully");
    });
    promise.then(
      (result) => {
        const activity = scrollRef.current.getElementsByClassName("activity_wrapper");
        let addedActivity = activity[activity.length - 1].getBoundingClientRect();
        scrollRef.current.scrollLeft += addedActivity.left;
      },
      function (error) { }
    );
  };

  const removeActivity = (idx) => {
    if (isVideo) {
      dispatch(removeUserActivity({ idx }));
    } else {
      if (userActivities.length <= 1) return;
      toast.success("Successfully deleted", {
        toastId: "Page deleted",
      });
      dispatch(removeUserActivity({ idx }));
    }
  };
  const selectActivity = (idx) => dispatch(selectUserActivity(idx));

  const handleDuplicate = () => dispatch(duplicateUserActivity(userActivities[selectedUserActivity]));
  useDisableBodyScroll(slidesActive);

  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  const openPrefModal = (activity) => {
    console.log('activity', activity)
    let timestamp = 0
    let dropdownId = 1
    if (activity.question_id) {
      timestamp = activity.question_id.timestamp ? activity.question_id.timestamp : 0
    }
    if (timestamp === 0) {
      dropdownId = 2
    } else if (timestamp > 0) {
      dropdownId = 1
    } else {
      dropdownId = 3
    }
    dispatch(togglePreference({
      preferenceActive: true,
      defaultPreference: {
        timestamp: timestamp, dropdownId: dropdownId
      },
      preferenceEditing: true
    }))
  }

  const dragStart = (e, position) => {
    // console.log('start');
    dragItem.current = position;
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const drop = (e) => {
    let copyListItems = [...userActivities];
    let defListItems = [...defaultUserActivities];
    //dragItem.current is index
    if (dragItem.current === null) return;
    if (dragOverItem.current === null) return;

    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);

    // for user activities
    // let itemOne = copyListItems[dragItem.current];
    // copyListItems[dragItem.current] = copyListItems[dragOverItem.current];
    // copyListItems[dragOverItem.current] = itemOne;

    // for default user activities
    let defItemOne = defListItems[dragItem.current];
    defListItems[dragItem.current] = defListItems[dragOverItem.current];
    defListItems[dragOverItem.current] = defItemOne;

    dragItem.current = null;
    dragOverItem.current = null;

    if (copyListItems !== null)
      return dispatch(
        setUserActivity({
          activities: copyListItems,
          defaultActivities: defListItems,
        })
      );
  };

  // console.log(userActivities.sort((a,b) => a.question_id.timestamp - b.question_id.timestamp))
  let tapedId = null;
  function handleDoubleTap(event, idx) {
    if (tapedId !== idx) {
      tapedId = idx;
      setTimeout(function () {
        tapedId = null;
      }, 400);
      return false;
    }
    event.preventDefault();
    selectActivity(idx);
    setSlidesActive(false);
  }

  /* Scroll onClick */
  const onclick_left_btn = () => {
    scrollRef.current.scrollLeft = scrollRef.current.scrollLeft - 400;
  };
  const onclick_right_btn = () => {
    scrollRef.current.scrollLeft = scrollRef.current.scrollLeft + 400;
  };

  useEffect(() => {
    if (width > 1275 && scrollRef.current?.scrollWidth > scrollRef.current?.offsetWidth) {
      scrollRef.current.classList.add("pagination_btn_active");
    } else {
      scrollRef.current.classList.remove("pagination_btn_active");
    }
  }, [scrollRef?.current?.scrollWidth]);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {isVideo &&
        <>
          <VideoController playerRef={playerRef} videoDetails={videoDetails} />
        </>
      }
      <div className="activity_container__pagination pagination_btn_active" id={slidesActive ? "slides-active" : "display-none"} ref={scrollRef}

      >
        <div className="pagination_activities">
          {isVideo ?
            [...userActivities].map((activity, idx) => {
              let timer = activity?.question_id?.timestamp === -1 ? -1 : getTime(activity?.question_id?.timestamp)
              // console.log('question_id.timer', activity.question_id.timer);
              return (
                <div
                  key={idx}
                  className="activity_wrapper"
                >
                  <div className="activity_number">{idx + 1}</div>
                  <div key={idx} className={`activity ${selectedUserActivity === idx ? "active" : ""}`} onTouchStart={(e) => handleDoubleTap(e, idx)} onClick={() => selectActivity(idx)}>
                    {isEditing && activity.theme_id && (
                      <img src={activity.theme_id && activity.theme_id.thumbnail_data ? activity.theme_id.thumbnail_data.uri : activity.theme_id.thumbnail} style={{ width: "100%" }} alt="" />
                    )}

                    {!isEditing && activity.theme_id && activity.theme_id.thumbnail_data && <img src={activity.theme_id.thumbnail_data.uri} style={{ width: "100%" }} alt="" />}
                  </div>
                  <img src={MenuIcon} className='pagination-activity-menu'
                    onClick={() => { openPrefModal(activity); selectActivity(idx) }} />
                  <div className="pagination-timer">
                    {
                      timer.minutes === 0 && timer.seconds === 0 ?
                        <p className="pre-video">
                          Pre video
                        </p>
                        : timer === -1 ?
                          <p className="pre-video">
                            Post video
                          </p> :
                          <p className="on-video">
                            {`${timer.minutes > 9 ? timer.minutes : `0${timer.minutes}`}:${timer.seconds > 9 ? timer.seconds : `0${timer.seconds}`}`}
                          </p>

                    }
                  </div>
                  {userActivities.length >= 1 && (
                    <div className=" pagination_activities__option_remove_btn" onClick={() => removeActivity(idx)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 16 16" fill="">
                        <path
                          d="M15.3812 3.04103C15.8923 2.52988 15.8923 1.70115 15.3812 1.19C14.8701 0.678854 14.0413 0.678854 13.5302 1.19L8.28561 6.43457L3.04104 1.19C2.5299 0.678855 1.70116 0.678854 1.19002 1.19C0.67887 1.70115 0.678871 2.52988 1.19002 3.04103L6.43458 8.28559L1.19 13.5302C0.678854 14.0413 0.678854 14.8701 1.19 15.3812C1.70115 15.8923 2.52988 15.8923 3.04103 15.3812L8.28561 10.1366L13.5302 15.3812C14.0413 15.8924 14.8701 15.8924 15.3812 15.3812C15.8924 14.8701 15.8924 14.0413 15.3812 13.5302L10.1366 8.28559L15.3812 3.04103Z"
                          fill="#000"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              );
            }) :
            userActivities.map((activity, idx) => {
              // console.log('pag activity', activity);
              let activityObjLength = Object.keys(activity).length
              return (
                <div
                  key={idx}
                  className="activity_wrapper"
                  draggable
                  onDragStart={(e) => dragStart(e, idx)}
                  onTouchStart={(e) => dragStart(e, idx)}
                  onDragOver={(e) => dragEnter(e, idx)}
                  onTouchMove={(e) => dragEnter(e, idx)}
                  onDragEnd={drop}
                  onTouchEnd={drop}
                // onTouchCancel={drop}
                >
                  <div className="activity_number">{idx + 1}</div>
                  <div key={idx} className={`activity ${selectedUserActivity === idx ? "active" : ""}`} onTouchStart={(e) => handleDoubleTap(e, idx)} onClick={() => selectActivity(idx)}>
                    {isEditing && activityObjLength > 3 && activity.theme_id && (
                      <img src={activity.theme_id && activity.theme_id.thumbnail_data ? activity.theme_id.thumbnail_data.uri : activity.theme_id.thumbnail} style={{ width: "100%" }} alt="" />
                    )}
                    {!isEditing && activityObjLength > 3 && activity.theme_id && activity.theme_id.thumbnail_data &&
                      <img src={activity.theme_id.thumbnail_data.uri} style={{ width: "100%" }} alt="" />}
                  </div>
                  {userActivities.length > 1 && (
                    <div className=" pagination_activities__option_remove_btn" onClick={() => removeActivity(idx)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 16 16" fill="">
                        <path
                          d="M15.3812 3.04103C15.8923 2.52988 15.8923 1.70115 15.3812 1.19C14.8701 0.678854 14.0413 0.678854 13.5302 1.19L8.28561 6.43457L3.04104 1.19C2.5299 0.678855 1.70116 0.678854 1.19002 1.19C0.67887 1.70115 0.678871 2.52988 1.19002 3.04103L6.43458 8.28559L1.19 13.5302C0.678854 14.0413 0.678854 14.8701 1.19 15.3812C1.70115 15.8923 2.52988 15.8923 3.04103 15.3812L8.28561 10.1366L13.5302 15.3812C14.0413 15.8924 14.8701 15.8924 15.3812 15.3812C15.8924 14.8701 15.8924 14.0413 15.3812 13.5302L10.1366 8.28559L15.3812 3.04103Z"
                          fill="#000"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              );
            })
          }
          {
            isVideo ?
              <>
                <img src={AddActivityIcon} className="add-activity-icon" onClick={addVideoActivity} alt="" />
                <span style={{ whiteSpace: 'nowrap', display: 'inline-block', paddingLeft: '4px', cursor: 'pointer' }} > Add slide </span>
              </> :
              <img src={AddActivityIcon} className="add-activity-icon" onClick={addActivity} alt="" />
          }
        </div>
        <div className="activity_container__pagination__footer">
          <div className="icons_container">
            <img src="/assets/icons/duplicate.svg" onClick={handleDuplicate} alt="" />
            <img src="/assets/icons/plus-circle.svg" onClick={addActivity} alt="" />
            <img src="/assets/icons/delete.svg" onClick={() => removeActivity(selectedUserActivity)} alt="" />
          </div>
        </div>
        <div className="activity_container__pagination__cross_icon" onClick={() => setSlidesActive(false)}>
          <img src="/assets/icons/cross-circle.svg" alt="" />
        </div>

        <button className="activity_pagination__scroll_btn scroll_onclick_left" onClick={onclick_left_btn}>
          <svg width={10} height={18} viewBox="0 0 18 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.2811 31.2601C18.2396 30.2735 18.2396 28.6739 17.2811 27.6873L5.9258 16L17.2811 4.31269C18.2396 3.32611 18.2396 1.72653 17.2811 0.739943C16.3225 -0.246647 14.7684 -0.246647 13.8098 0.739943L0.71892 14.2136C-0.23964 15.2002 -0.23964 16.7998 0.71892 17.7864L13.8098 31.2601C14.7684 32.2466 16.3225 32.2466 17.2811 31.2601Z"
              fill="black"
            />
          </svg>
        </button>

        <button className="activity_pagination__scroll_btn scroll_onclick_right" onClick={onclick_right_btn}>
          <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.583619 0.861432C1.09485 0.335252 1.92372 0.335252 2.43495 0.861432L9.41677 8.0474C9.928 8.57358 9.928 9.42668 9.41677 9.95286L2.43495 17.1388C1.92372 17.665 1.09485 17.665 0.583619 17.1388C0.0723874 16.6126 0.0723874 15.7595 0.583619 15.2334L6.63977 9.00013L0.583619 2.7669C0.0723874 2.24072 0.0723874 1.38761 0.583619 0.861432Z"
              fill="black"
              fillRule="evenodd"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );
}
